import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { PopoverItem, Text } from '@hub-la/design-system';
import { ListItemIcon } from '@mui/material';

const MenuLink = props => {
  if (props === null || props === void 0 ? void 0 : props.hidden) return null;
  return jsxs(PopoverItem, Object.assign({
    onClick: props.onClick,
    sx: {
      padding: 3
    },
    selected: props.selected
  }, {
    children: [props.startIcon && jsx(ListItemIcon, {
      children: props.startIcon
    }), jsx(Text, Object.assign({
      color: "onSurfaceVariant"
    }, {
      children: props.label
    })), props.endIcon && jsx(ListItemIcon, Object.assign({
      sx: {
        marginLeft: 'auto',
        minWidth: 'auto !important'
      }
    }, {
      children: props.endIcon
    }))]
  }));
};

export { MenuLink };
